// extracted by mini-css-extract-plugin
export default {"container":"style_container__w+y7i","titleOverlay":"style_titleOverlay__ZtcFQ","mobileTitle":"style_mobileTitle__iivkY","content":"style_content__icTfr"};